import {Message} from 'element-ui'

export const showErrors = {
    showFormErrors (error, formName = 'form') {
        for (let f = 0; f < this.$refs[formName].fields.length; f++) {
            if (this.$refs[formName] && this.$refs[formName].fields[f] && this.$refs[formName].fields[f].prop && error.propertyErrors && error.propertyErrors[this.$refs[formName].fields[f].prop]) {
                let err = error.propertyErrors[this.$refs[formName].fields[f].prop][0]
                if (this.$refs[formName].fields[f].label) {
                    let displayName = '{' + this.$refs[formName].fields[f].prop + '}'
                    let fieldName = this.$refs[formName].fields[f].prop
                    fieldName = fieldName.charAt(0).toUpperCase() + fieldName.slice(1)
                    if (err.search(displayName) !== -1) {
                        err = err.replace('{' + this.$refs[formName].fields[f].prop + '}', this.$refs[formName].fields[f].label)
                    }
                    if (err.search(fieldName) !== -1) {
                        err = err.replace(fieldName, this.$refs[formName].fields[f].label)
                    }
                }
                this.$refs[formName].fields[f].validateMessage = err
                this.$refs[formName].fields[f].validateState = 'error'
            }
        }
    },
    clearFormErrors (formName = 'form') {
        if (!this.$refs[formName] || !this.$refs[formName].fields) return
        for (let f = 0; f < this.$refs[formName].fields.length; f++) {
            this.$refs[formName].fields[f].validateMessage = ''
            this.$refs[formName].fields[f].validateState = ''
        }
    }
}

export const catchErrors = function (error) {
    let errorMsg
    if (!error.response) return

    if (error.response.status === 401) {
        let url = window.location.href.toString().split(window.location.host)[1]
        if (url !== '/login') {
            location.reload('/login')
        }
    }
    if (error.response.status === 403) {
        window.location = '/forbidden'
    }
    if (error.response) {
        let dangerouslyUseHTMLString = false
        let data = error.response.data
        if (data.code) {
            switch (data.code) {
            case 'MultipleErrors':
                errorMsg = ''
                for (let i = 0; i < data.multipleErrors.length; i++) {
                    errorMsg += data.multipleErrors[i].message + '\n'
                }
                break
            case 'ValidationError':
                errorMsg = data.propertyErrors[Object.keys(data.propertyErrors)[0]][0]
                return Promise.reject(error.response.data)
            case 'file':
                return Promise.reject(error.response.data)
            default:
                errorMsg = data.message.replace(/\n/, '<br>')
                dangerouslyUseHTMLString = true
                break
            }
        }
        else if (data.errors && Object.keys(data.errors).length > 0) {
            errorMsg = ''
            Object.keys(data.errors).map(function(key) {
                errorMsg += data.errors[key] + '<br>'
            });
            dangerouslyUseHTMLString = true
        } else {
            // errorMsg = error.response.statusText
            return Promise.reject(error.response.data)
        }
        Message({
            dangerouslyUseHTMLString: dangerouslyUseHTMLString,
            message: errorMsg + '111',
            type: 'error',
            duration: 8 * 1000
        })
        return Promise.reject(error.response.data)
    } else if (error.request) {
        console.log(error.request)
        errorMsg = 'The request was made but no response was received'
        Message({
            message: errorMsg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error.request)
    } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', error.message)
        errorMsg = error.message
        Message({
            message: errorMsg,
            type: 'error',
            duration: 5 * 1000
        })
        return Promise.reject(error)
    }
}
